{
	"current_lang": "FR",
	"shared_mailbox": "Boîtes mail partagées",
	"shared_mailbox_description": "<strong>Une adresse mail, une équipe.</strong><br>Crée une adresse d'équipe et gère-la à plusieurs : chaque collaborateur peut envoyer et recevoir des messages sur cette adresse, sans quitter son interface Gmail.",
	"service_account": "Comptes de services",
	"service_account_description": "<strong>Pilote tes comptes de service.</strong><br> Un compte de service est une identité technique utilisée par une application ou un script pour accéder aux services Google sans intervention humaine. Il permet de centraliser tes ressources partagées et de sécuriser tes automatisations entre les membres autorisés.",
	"account_health": "Santé du compte",
	"account_health_description": "<strong>Assure-toi que tout est en ordre.</strong><br>Vérifie toutes tes informations d'identité sont bien synchronisées.",
	"account_health_no_access_message_title": "Désolé, tu n'as pas accès à la gestion de santé des comptes.",
	"account_health_no_access_message_description": "Pour devenir gestionnaire de la santé des comptes, tu dois faire la demande d'accès ",
	"associated_site_resource_management": "Gestion des Sites et de leurs Ressources associées",
	"site_resource_management": "Gestion des Sites et de leurs Ressources",
	"site_resource_management_description": "Gère tes sites et tout ce qui les compose : salles, équipements, moyens de transport…",
	"resource_management_mygoogle": "Gestion des ressources",
	"resource_associated": "Ressource associée",
	"resource_details": "Détails de la ressource",
	"resource_management_description": "<strong>Centralise la gestion de tes sites au même endroit.</strong><br>Crée tes buildings, configure chaque salle et ses équipements, gère les accès aux calendriers et extrais les données d’utilisation de ton site en un clin d’œil.",
	"resource_management_calendar_admin": "Gestion de ressource admin",
	"resource_management_calendar_admin_description": "Permet de voir les évenements du calendrier d'une ressource sur Google Calendar. Choisis ton site, et selectionne ta ressource !",
	"resource_associated_deleted": "Liste des ressources associées à supprimer ({ressourcesNumber})",
	"resource_calendar_admin_access": "Accès admin au calendrier des ressources",
	"resource_calendar_admin_access_description": "<strong>Garde le contrôle sur tes ressources.</strong><br>Tu peux gérer tes droits d'administration sur l'agenda d'une ressource pour modifier ses événements directement dans Google Calendar.",
	"create_shared_mailbox": "Créer une boîte mail partagée",
	"create_shared_mailbox_success": "Boîte mail partagée créée",
	"create_shared_mailbox_success_description": "La boîte mail partagée a bien été créée",
	"shared_mailbox_creation_in_progress": "Création de la boîte mail partagée",
	"shared_mailbox_creation_step_message_1": "La boîte mail partagée est en cours de création, cela peut durer quelques minutes. Voici les étapes en cours",
	"shared_mailbox_creation_step_message_2": "Tu peux garder cette page ouverte pendant la création. Tu pourras ajouter des délégués une fois la création terminée.",
	"shared_mailbox_creation_steps": "Étapes de création de la boîte mail partagée",
	"shared_mailbox_creation_step_label": "Étape {step}",
	"edit_shared_mailbox": "Modifier une boîte mail partagée",
	"edit_shared_mailbox_title": "Modifier la boîte mail partagée \"{name}\"",
	"visualize_shared_mailbox_title": "Visualiser la boîte mail partagée \"{name}\"",
	"edit_the_mailbox": "Modifier la boîte mail",
	"edit_shared_mailbox_success": "Boîte mail partagée modifiée",
	"edit_shared_mailbox_success_description": "La boîte mail partagée a bien été modifiée",
	"renew_shared_mailbox_success": "La boîte mail partagée a bien été renouvelée",
	"delete_shared_mailbox_success": "Boîte mail partagée supprimée",
	"delete_shared_mailbox_success_description": "La boîte mail partagée a bien été supprimée",
	"create_mailbox": "Créer une boîte mail",
	"cancel": "Annuler",
	"reminder": "Rappel",
	"reminder_message_shared_mailbox": "<strong>Une adresse e-mail, une équipe.</strong><br>Créez une adresse d'équipe et gérez-la ensemble : chaque coéquipier peut envoyer et recevoir des e-mails avec cette adresse sans quitter son interface Gmail.",
	"reminder_create_shared_mailbox": "On fait le point tous les 6 mois.",
	"reminder_create_shared_mailbox_message": "Par défaut, ta boîte partagée est active pour une durée de 6 mois.<br> Pas d'inquiétude : on t'envoie un email quand l'échéance approche. Sans action de ta part, elle sera supprimée automatiquement pour garder l'espace propre.",
	"address": "Adresse",
	"description": "Description",
	"type": "Type",
	"create_shared_mailbox_form_adress": "L’adresse de ta boîte mail partagée.",
	"create_shared_mailbox_form_description": "Quel est l'objectif de cette boîte mail et à qui est-elle destinée ?",
	"create_shared_mailbox_form_description_placeholder": "Quel est l'objectif de cette boîte mail et à qui est-elle destinée ?",
	"create_shared_mailbox_form_delegate": "Les délégués peuvent modifier ou supprimer cette boîte mail partagée.",
	"expired": "Expirée",
	"imminent": "Imminente",
	"status_expired": "Expirée",
	"status_imminent": "Imminente",
	"expiration": "Expiration",
	"expire": "Expire",
	"expire_on": "expire le",
	"owners": "Propriétaires",
	"owner": "Propriétaire",
	"holder": "Propriétaire",
	"holder_right_description": "droits de manager + responsable du compte (facturation...)",
	"managers": "Managers",
	"manager": "Manager",
	"manager_right_description": "droits de membre + changer de propriétaire",
	"delegate": "Délégué",
	"delegates": "Délégués",
	"days": "jours",
	"in": "dans",
	"delete": "Supprimer",
	"edit": "Modifier",
	"create": "Créer",
	"see_detail": "Voir le détail",
	"renew": "Renouveler",
	"delete_message": "Veux-tu supprimer cette boîte mail partagée : {mail} ?",
	"empty_shared_mailbox": "Tu n'as pas encore de boîte mail partagée...",
	"delete_shared_mailbox": "Supprimer la boîte mail partagée",
	"delete_mailbox": "Supprimer la boîte mail",
	"add_delegates": "Ajouter des délégués",
	"add": "Ajouter",
	"back": "Retour",
	"scroll_up": "Faire défiler vers le haut",
	"scroll_down": "Faire défiler vers le bas",
	"scroll_position": "Position du défilement",
	"search_and_add_delegates": "Rechercher et ajouter des délégués à la boîte mail partagée",
	"add_by_name": "Ajouter par nom, UUID...",
	"add_by_email": "Ajouter par email",
	"email_not_found": "Email introuvable",
	"email_already_added": "Email déjà ajouté",
	"search_by_name": "Rechercher par nom, UUID...",
	"search_by_country": "Ajouter par pays...",
	"search_by_building": "Ajouter par bâtiment...",
	"search_by_department": "Ajouter par département...",
	"search_by_job": "Ajouter par métier...",
	"search_by_contract": "Ajouter par contrat...",
	"search_by_role": "Ajouter par rôle...",
	"search_by_mission": "Ajouter par mission...",
	"search_by_service": "Ajouter par service...",
	"search_shared_mailbox": "Rechercher une boîte mail partagée",
	"search_no_result": "Aucun résultat",
	"delete_delegate": "Supprimer le délégué",
	"delete_delegate_message": "Veux-tu supprimer le délégué suivant : {mail} ?",
	"delegate_form_message": "Rappel : les délégués peuvent modifier et renouveler cette boîte mail partagée.",
	"description_form_message": "Quel est l'objectif de cette boîte mail et à qui est-elle destinée ?",
	"renew_title": "Renouveler la boîte mail partagée",
	"renew_message": "Veux-tu renouveler cette boîte mail partagée: {mail} ?",
	"home_page_title": "Bienvenue sur MyGoogle.",
	"home_page_welcome_title": "Bienvenue sur MyGoogle",
	"home_page_description": "Avec MyGoogle, découvre des fonctionnalités avancées de ton compte Google, comme la gestion de boîtes mails partagées, de listes, ou encore de comptes de service !",
	"later": "Plus tard",
	"finish": "Terminer",
	"expiration_form_title": "Expiration",
	"expiration_form_message": "Rappel : Une boîte mail partagée a une durée de vie de 6 mois. Si besoin, tu pourras prolonger cette durée de 6 mois supplémentaires à l'approche de l'expiration.",
	"expiration_form_message_SA": "Rappel : Un compte de service a une durée de vie de 6 mois. Si besoin, tu pourras prolonger cette durée de 6 mois supplémentaires à l'approche de l'expiration.",
	"domain": "Domaine",
	"name": "Nom",
	"add_delegate_to_shared_mailbox": "Ajouter des délégués à votre boîte mail partagée",
	"delagates_title_information": "Votre boîte mail partagée est désormais créer vous pouvez maintenant ajouter des délégués sur celle-ci si vous le souhaitez",
	"delagates_title_information_message": "Un délégué aura la possibilité de consulter la boîte mail partagée, la modifier et la renouveler. Vous serez le seul à pouvoir la supprimer.",
	"loading": "Chargement en cours",
	"close_modal": "Fermer la fenêtre",
	"close": "Fermer",
	"banner_notification_access": "Notifications",
	"banner_notification_view_details": "Voir les détails",
	"close_alert": "Fermer l'alerte",
	"navigate": "Naviger",
	"no_description": "Pas de description",
	"no_expiration_date": "Pas de date d'expiration",
	"my_shared_mailbox": "Mes boîtes mails",
	"other_shared_mailbox": "Rechercher une boîte mail",
	"profile": "Profil",
	"home": "Accueil",
	"menu": "Menu",
	"mail": "Mail",
	"address_placeholder_SM": "Entre le nom de la boîte mail partagée ici",
	"address_placeholder_SAA": "Entre le nom du compte de service ici",
	"invalid_email_format": "Format d'email non valide",
	"invalid_email_format_desc": "L'email doit respecter le format prenom.nom@decathlon.com",
	"group_name_placeholder": "nom du groupe",
	"create_service_account": "Créer un compte de service",
	"create_the_service_account": "Créer le compte de service",
	"edit_service_account": "Modifier un compte de service",
	"edit_service_account_title": "Modifier le compte de service \"{name}\"",
	"visualize_service_account": "Visualiser un compte de service",
	"visualize_service_account_title": "Visualiser le compte de service \"{name}\"",
	"edit_the_service_account": "Modifier le compte de service",
	"edit_service_account_success": "Compte de service modifié",
	"edit_service_account_success_description": "Le compte de service a été modifié avec succès",
	"reminder_create_service_account": "On fait le point tous les 6 mois.",
	"reminder_create_service_account_message": "Par défaut, ton compte de service est actif pour une durée de 6 mois.<br> Pas d'inquiétude : on t'envoie un email quand l'échéance approche. Sans action de ta part ou de ton équipe, le compte sera automatiquement supprimé pour garder l'espace propre.",
	"create_service_account_form_name": "L’adresse de ton compte de service.",
	"create_service_account_form_description": "Quel est l'objectif de ce compte de service et à qui est-il destiné ?",
	"create_service_account_form_description_placeholder": "Quel est l'objectif de ce compte de service et à qui est-il destiné ?",
	"create_service_account_success": "Compte de service créé",
	"create_service_account_success_description": "Le Compte de service a bien été créé",
	"error_title": "Erreur",
	"error_mandatory_name": "Le Nom est obligatoire",
	"error_mandatory_description": "La Description est obligatoire",
	"invalid_name_format": "Format du nom invalide",
	"invalid_name_format_desc": "Le nom doit respecter le format nom.nom@decathlon.com",
	"error_conflict": "Conflit",
	"error_conflict_description": "Le nom existe déjà",
	"error_standard": "Une erreur est survenue",
	"name_too_short": "Nom trop court, minimum 3 caractères requis",
	"description_help": "Description d’au moins 5 caractères compréhensible.",
	"member": "Membre",
	"members": "Membres",
	"member_right_description": "visualiser et se connecter",
	"members_form_message": "Rappel: les membres peuvent modifier les membres du compte de service.",
	"members_title_information": "Votre compte de service est désormais créer vous pouvez maintenant ajouter des membres sur celui-ci si vous le souhaitez",
	"members_title_information_message": "Un membre aura la possibilité de se connecter au compte de service, le modifier et le renouveler. Vous serez le seul à pouvoir le supprimer.",
	"delete_member": "Supprimer le membre",
	"downgrade": "Rétrograder",
	"delete_manager_role": "Supprimer le rôle manager",
	"add_member_to_service_account": "Ajouter des membres à votre compte de service",
	"delete_member_message": "Veux-tu supprimer le membre suivant : {mail} ?",
	"delete_manager_role_message": "Veux-tu retirer le rôle de manager à : {mail} ?",
	"delete_manager_warning_message": "Attention : La suppression du manager ne le supprimera pas de la liste des membres.",
	"no_results_found": "Aucun résultat.",
	"reminder_service_account_message": "<strong>La force du collectif.</strong><br>Un compte de service permet à tes outils d’agir automatiquement avec les services Google. Il sert aussi à centraliser l’accès à des ressources partagées pour ton équipe. <br><em>À savoir : Pour des raisons de sécurité, un mot de passe temporaire sera généré à chaque nouvelle connexion.</em>",
	"my_service_accounts": "Mes comptes de services",
	"delete_service_account": "Supprimer le compte de service",
	"empty_service_account": "Vous ne faites partie d'aucun compte de service",
	"renew_service_account_title": "Renouveler le compte de service",
	"renew_service_account_message": "Veux-tu renouveler ce compte de service: {mail} ?",
	"delete_service_account_message": "Veux-tu supprimer ce compte de service : {mail} ?",
	"renew_service_account_success": "Le compte de service a été renouvelé avec succès",
	"delete_service_account_success": "Compte de service supprimé",
	"delete_service_account_success_description": "Le compte de service a été supprimé avec succès",
	"to_connect": "Se connecter",
	"extend": "Prolonger",
	"connect_service_account_title": "Identifiant de connexion au compte de service",
	"connect_service_account_description_part_1": "Pour accéder à votre compte de service, il est important de te connecter en mode '<b>navigation privée (Ctrl+Shift+N)</b>' sur le lien suivant :",
	"connect_service_account_description_part_2": "et d'utiliser les identifiants de connexions ci-dessous. Ils ne sont valables que 15 minutes.",
	"email": "Email",
	"password": "Mot de passe",
	"copy": "Copier",
	"copied": "Copie réussie !",
	"search_service_account": "Rechercher un compte de service",
	"search_group": "Rechercher un groupe",
	"group_ex_list": "Groupes (ex listes de diffusion)",
	"groups": "Groupes",
	"group": "Groupe",
	"group_display_modes": "Type d’affichage des groupes",
	"group_display_list": "Afficher les groupes en liste",
	"group_display_cards": "Afficher les groupes en cartes",
	"group_display_mini_cards": "Afficher les groupes en mini-cartes",
	"display_mode_modes": "Mode d’affichage",
	"display_mode_list": "Afficher en liste",
	"display_mode_cards": "Afficher en cartes",
	"display_mode_mini_cards": "Afficher en mini-cartes",
	"group_description": "<Strong>Mieux travailler ensemble.</Strong><br/> Crée et gère une adresse mail unique pour rassembler une liste d’utilisateurs. C'est l'outil idéal pour partager des documents, synchroniser des calendriers et les événements associés ou s'adresser à un groupe défini dans un espace de discussion.",
	"group_description_placeholder": "L'objectif de ce groupe et à qui il s'adresse",
	"create_group": "Créer un groupe",
	"create_group_add_managers_title": "Ajouter des managers à votre groupe",
	"group_managers_description": "Les managers peuvent modifier ou supprimer ce groupe.",
	"reminder_create_group": "Quelques règles pour ton groupe :",
	"reminder_create_group_step_3": "Un groupe est limité à 2500 membres sauf si vous êtes un communiquant.",
	"reminder_create_group_message_list_1": "<strong>Gère jusqu'à 2 500 membres :</strong> Qu'ils soient ajoutés via des filtres dynamiques ou manuellement (membres statiques), ton groupe est fait pour durer 6 mois.",
	"reminder_create_group_message_list_1_without_dynamic": "<strong>Gère jusqu'à 2 500 membres :</strong> En ajoutant tes membres manuellement (membres statiques), ton groupe est fait pour durer 6 mois.",
	"reminder_create_group_message_step_3_list_1": "Un membre statique devra être géré manuellement par les managers du groupe.",
	"reminder_create_group_message_list_2": "<strong>Garde un œil sur l'échéance :</strong> Nous te préviendrons par e-mail avant la fin des 6 mois, mais n’hésite pas à agir en amont pour éviter la suppression du groupe.",
	"reminder_create_group_message_list_3": "<strong>Choisis le bon type de groupe :</strong> Ce choix est définitif. Pour changer le type, il faudra créer un nouveau groupe. ",
	"reminder_create_group_message_list_3_without_dynamic": "<strong>Ton groupe sera statique :</strong> Les membres seront ajoutés et gérés manuellement par les managers.",
	"reminder_create_group_add_managers": "Un manager aura le même droit que toi sur le groupe",
	"reminder_create_group_add_managers_message_list_1": "Il pourra modifier le groupe et y ajouter de nouveaux membres",
	"reminder_create_group_add_managers_message_list_2": "Il pourra supprimer le groupe",
	"reminder_create_group_message_step_3_list_2": "Un membre dynamique sera automatiquement gérer par l’application si il ne respecte plus les conditions du filtre dynamique.",
	"reminder_create_group_message_step_3_list_2_without_dynamic": "Tu seras notifié par e-mail avant l'échéance. Sans action des managers, le groupe sera automatiquement supprimé.",
	"create_group_form_name": "L’adresse de ton groupe, sans majuscule et sans accent.",
	"create_group_form_description": "Quel est l'objectif de ce groupe et à qui est-il destiné ?",
	"create_group_form_type": "Les différents types de groupes :<br><br>• <strong>Les groupes statiques</strong> : Ajoute des membres manuellement, un par un. C’est la solution idéale pour garder un contrôle total sur ta liste, qui n'évolue que lorsque tu le décides.<br><br>• <strong>Les groupes dynamiques</strong> : Définis tes propres filtres et laisse la liste se mettre à jour toute seule : les membres évoluent selon tes critères, sans aucune action de ta part.",
	"group_type_description_title": "<strong>Les différents types de groupe :</strong>",
	"group_type_description_static": "<strong>Les groupes statiques :</strong> Ajoute des membres manuellement, un par un. C'est la solution idéale pour garder un contrôle total sur ta liste, qui n'évolue que lorsque tu le décides.<br/><br/>",
	"group_type_description_dynamic": "<strong>Les groupes dynamiques :</strong> Définis tes propres filtres et laisse la liste se mettre à jour toute seule : les membres évoluent selon tes critères, sans aucune action de ta part.",
	"save_the_description": "Enregistrer la description",
	"edit_group": "Modifier le groupe",
	"visualize_group": "Visualiser le groupe",
	"create_the_group": "Créer le groupe",
	"create_group_static_success": "Groupe statique créé",
	"create_group_static_success_description": "Le groupe statique a bien été créé",
	"create_group_dynamic_success": "Groupe dynamique créé",
	"create_group_dynamic_success_description": "Le groupe dynamique a bien été créé",
	"empty_group": "Vous n'avez pas de groupes",
	"renew_group_title": "Renouveler le groupe",
	"renew_group_message": "Veux-tu renouveler ce groupe: {mail} ?",
	"renew_group_succeess": "Le groupe a bien été renouvelé",
	"delete_the_group": "Supprimer le groupe",
	"edit_the_group": "Editer le groupe",
	"manage_the_group": "Gérer le groupe",
	"delete_group_message": "Veux-tu supprimer ce groupe : {mail} ?",
	"delete_group_success": "Groupe supprimé",
	"delete_group_success_description": "Le groupe a bien été supprimé",
	"create_static_group": "Créer un groupe statique",
	"create_dynamic_group": "Créer un groupe dynamique",
	"next": "Suivant",
	"managers_form_message": "Les managers peuvent modifier ou supprimer ce groupe",
	"add_members": "Ajouter des membres",
	"manage_members": "Gérer des membres",
	"create_group_form_add_members_static_group": "Permet d'ajouter / supprimer des membres statiques",
	"create_group_form_add_members_dynamic_group": "Permet d'ajouter / supprimer des membres statiques ou des filtres",
	"add_static_members": "Ajouter des membres statiques",
	"manage_static_members": "Gérer des membres statiques",
	"delete_static_members": "Supprimer des membres statiques",
	"add_static_members_description_modal": "Rechercher et ajouter des personnes en tant que membres statiques pour votre groupe",
	"delete_static_members_description_modal": "Rechercher et supprimer des personnes en tant que membres statiques pour votre groupe",
	"add_static_members_description": "Permet d'ajouter / supprimer des membres statiques.",
	"add_dynamic_members": "Ajouter des membres dynamique",
	"manage_dynamic_members": "Gère tes membres dynamiques !",
	"add_dynamic_members_description": "Ajoute ou retire des membres en quelques clics grâce aux filtres.",
	"add_dynamic_members_description_information": "<strong>Attention :</strong> Modifier tes filtres impacte directement ta liste de membres. Plus tu ajoutes de critères, plus ta sélection est ciblée et restreinte.",
	"filter_by_managers": "Filtrer par managers",
	"filter_by_jobs": "Filtrer par métiers",
	"filter_by_countries": "Filtrer par pays",
	"filter_by_buildings": "Filtrer par bâtiments",
	"filter_by_departments": "Filtrer par départements",
	"filter_by_sports": "Filtrer par sports",
	"filter_by_contracts": "Filtrer par contrats",
	"filter_by_roles": "Filtrer par rôles",
	"filter_by_missions": "Filtrer par missions",
	"filter_by_services": "Filtrer par services",
	"import": "importer",
	"massive_import": "Import massif",
	"massive_import_modal_title": "Import groupé des membres",
	"search_and_add_managers": "Rechercher et ajouter des managers pour votre groupe",
	"search_and_add_countries": "Rechercher et ajouter des pays pour votre groupe",
	"search_and_add_buildings": "Rechercher et ajouter des bâtiments pour votre groupe",
	"search_and_add_departments": "Rechercher et ajouter des départements pour votre groupe",
	"search_and_add_jobs": "Rechercher et ajouter des métiers pour votre groupe",
	"search_and_add_contracts": "Sélectionne un ou plusieurs type(s) de contrat(s) à filtrer dans la liste des membres.",
	"search_and_add_roles": "Rechercher et ajouter des rôles pour votre groupe",
	"search_and_add_missions": "Rechercher et ajouter des missions pour votre groupe",
	"search_and_add_services": "Rechercher et ajouter des services pour votre groupe",
	"edit_managers_success": "Managers modifiés",
	"edit_countries_success": "Pays modifiés",
	"edit_buildings_success": "Bâtiments modifiés",
	"edit_departments_success": "Départements modifiés",
	"edit_jobs_success": "Métiers modifiés",
	"edit_contracts_success": "Contrats modifiés",
	"edit_roles_success": "Rôles modifiés",
	"edit_missions_success": "Missions modifiés",
	"edit_services_success": "Services modifiés",
	"edit_managers_success_description": "Les filtres des managers ont été modifiés avec succès.",
	"edit_countries_success_description": "Les filtres des pays ont été modifiés avec succès.",
	"edit_buildings_success_description": "Les filtres des bâtiments ont été modifiés avec succès.",
	"edit_departments_success_description": "Les filtres des départements ont été modifiés avec succès.",
	"edit_jobs_success_description": "Les filtres des métiers ont été modifiés avec succès.",
	"edit_contracts_success_description": "Les filtres des contrats ont été modifiés avec succès.",
	"edit_roles_success_description": "Les filtres des rôles ont été modifiés avec succès.",
	"edit_missions_success_description": "Les filtres des missions ont été modifiés avec succès.",
	"edit_services_success_description": "Les filtres des services ont été modifiés avec succès.",
	"add_people": "Ajouter des personnes",
	"my_groups": "Mes groupes",
	"groups_im_part_of": "Groupes dont je fais partie",
	"edit_group_success": "Groupe modifié",
	"edit_group_success_description": "Le groupe a été modifié avec succès",
	"delete_manager_success": "Manager supprimé",
	"delete_manager_success_description": "Le manager a bien été supprimé",
	"add_manager_success": "Manager ajouté",
	"add_manager_success_description": "Le manager a bien été ajouté",
	"add_manager_process_success_description": "Votre demande est en cours de traitement. Le manager sera disponible dans quelques minutes",
	"group_details": "Détails du groupe",
	"members_list": "Liste des membres",
	"country_not_found": "Aucun pays trouvé",
	"select_one_file": "Selectionnez un fichier",
	"confirm": "Valider",
	"import_progress": "Import en cours",
	"massive_import_information": "et remplace uniquement les e-mails d'exemple par ta liste d'adresses e-mail.",
	"download_our_template": "Télécharge notre modèle",
	"massive_import_information_2": "Ensuite, importe le fichier et confirme l'envoi.",
	"massive_import_drag_and_drop_message": "Glisse ton fichier ici pour commencer le téléchargement",
	"massive_import_file_type": "Format pris en charge :",
	"massive_import_wrong_file_type_title": "Erreur d'importation",
	"massive_import_wrong_file_type_description": "Type de fichier non supporté. Utilise un fichier .csv.",
	"massive_import_success_message": "Attend de recevoir le mail qui te préviendra que le groupe est prêt avant de voir le groupe mis à jour !",
	"first_step_massive_import": "Sélectionnez un fichier avec la liste des membres du groupe (email)",
	"third_step_massive_import": "Attendez le mail qui vous préviendra que le groupe est prêt avant de voir le groupe mis à jour. Vous pouvez cliquer sur Terminer.",
	"massive_import_success": "Import massive terminée",
	"massive_import_success_description": "L'import massive a été réalisée avec succès",
	"massive_import_alert_2500_members": "La liste des membres dépasse 2500. Essaie avec un autre fichier ou mets à jour la liste actuelle.",
	"search_group_member": "Rechercher un membre du groupe (3 caractères minimum)",
	"add_member_success": "Membre ajouté",
	"add_member_success_description": "Le membre a bien été ajouté",
	"delete_member_success": "Membre supprimé",
	"delete_member_success_description": "Le membre a bien été supprimé",
	"add_delegate_success": "Délégué ajouté",
	"add_delegate_success_description": "Le délégué a bien été ajouté",
	"delete_delegate_success": "Délégué supprimé",
	"delete_delegate_success_description": "Le délégué a bien été supprimé",
	"edit_sa_role_member_success": "Rôle membre modifié",
	"edit_sa_role_member_success_description": "Le rôle du membre a bien été modifié",
	"manage_managers": "Gérer des managers",
	"manage_countries": "Gérer des pays",
	"manage_buildings": "Gérer des bâtiments",
	"manage_departments": "Gérer des départements",
	"manage_jobs": "Gérer des métiers",
	"manage_contracts": "Choisir le type de contrat dans les critères de sélection.",
	"manage_roles": "Gérer des rôles",
	"manage_missions": "Gérer des missions",
	"manage_services": "Gérer des services",
	"save": "Enregistrer",
	"dark_mode_actived": "Mode sombre activé",
	"light_mode_activated": "Mode clair activé",
	"theme_mode_light": "Clair",
	"theme_mode_dark": "Sombre",
	"redirected_to": "redirigé vers",
	"english": "Englais",
	"French": "Français",
	"selecte_language": "Sélectionner la langue",
	"selected_language": "Langue sélectionnée",
	"shared_mailbox_description_label": "Description de la boîte mail partagée",
	"group_description_label": "Description du groupe",
	"saa_description_label": "Description du compte de service",
	"shared_mailbox_status_label": "Statut de la boîte mail partagée",
	"saa_status_label": "Statut du compte de service",
	"modify_shared_mailbox_description": "Modifier la description de la boîte mail partagée",
	"modify_saa_description": "Modifier la description du compte de service",
	"modify_group_description": "Modifier la description du groupe",
	"extend_lifespan_of_shared_mailbox": "Prolonger la durée de vie de la boîte mail partagée de 6 mois supplémentaires",
	"extend_lifespan_of_saa": "Prolonger la durée de vie du compte de service de 6 mois supplémentaires",
	"members_list_shared_mailbox": "Liste des membres de la boîte mail partagée",
	"members_list_saa": "Liste des membres du compte de service",
	"members_list_group": "Liste des membres du groupe",
	"member_role": "Rôle du membre",
	"search_&_add_new_person": "Rechercher et ajouter un nouveau {role} par nom, email ou UID",
	"search": "Rechercher",
	"add_owner_shared_mailbox": "Ajouter un nouveau propriétaire",
	"become_the_new_owner": "Devenir le nouveau propriétaire",
	"go_back_previous_screen": "Revenir à l'écran précédent",
	"empty_delegates_list_title": "Devenez le nouveau propriétaire de la Sharemailbox",
	"empty_delegates_list_message": "Oups, cette boîte mail partagée ne peut pas être gérée car elle n'a plus de propriétaire. Pour continuer, vous devez devenir propriétaire ou demander a la bonne personne de se connecter sur cet écran.",
	"add_new_owner_shared_mailbox_success_title": "Nouveau propriétaire ajouté",
	"add_new_owner_shared_mailbox_success_description": "Le nouveau propriétaire a été ajouté avec succès.",
	"email_or_uid": "Email ou UID",
	"display_name": "Nom d'affichage",
	"primary_address": "Adresse principale",
	"job": "Emploi",
	"branch": "Branche",
	"country": "Pays",
	"site_name": "Nom du site",
	"aliases": "Alias",
	"is_boss": "Est le patron",
	"creation_date": "Date de création",
	"last_login_date": "Dernière date de connexion",
	"contract_type": "Type de contrat",
	"state": "État",
	"2_step_authent": "Authentification en 2 étapes",
	"mobile_infos": "Infos Mobiles",
	"possible_actions": "Actions possibles",
	"buildings": "Sites",
	"buildings_management": "Gestion des Sites et de leurs Ressources associées",
	"buildings_management_reminder": "Seuls ceux qui ont le rôle \"MyGoogle - Site Management\" sur Identity Access peuvent modifier ou supprimer un site. Pour devenir site manager, faites la demande sur ",
	"buildings_management_description": "<strong>Pilote des ressources en toute simplicité.</strong><br>Tu peux créer et manager des sites ainsi que leurs ressources (salle de réunion, matériel informatique, véhicules d’emprunt…) en toute simplicité !",
	"building_create": "Création d’un nouveau Site",
	"building_new_create": "Créer un nouveau site",
	"building_creation_success": "Création terminée",
	"building_creation_success_description": "Le site a été créé avec succès.",
	"building_reminder_description": "Seul le mode Affichage est activé si vous n'êtes pas gestionnaire du site.",
	"building_form_id_description": "L'identifiant du site est la combinaison CodePays-Ville-NomDuSite, site-id: {buildingId}",
	"building_form_adress_description": "Copiez collez l'adresse de la carte",
	"building_form_areas_floors_description": "Sont utilisés pour regrouper vos salles dans votre site pour aider les utilisateurs à les retrouver rapidement. Il peut s'agir d'étages, de points cardinaux, …",
	"building_form_areas_floors_placeholder": "Surfaces et étages séparés par une virgule “,”",
	"building_before_deletion_title": "Avant de pouvoir supprimer le site {building} :",
	"building_delete": "Supprimer le Site",
	"building_deletion_title": "Veux-tu vraiment supprimer le site {building} ?",
	"building_deletion_watch_out": "Ce choix est définitif, tu ne pourras pas revenir en arrière.",
	"building_deletion_resources": "Cette action va supprimer toutes les Ressources associées à <span class=\"vtmn-font-bold\">{building}</span>.",
	"building_deletion_warning": "ATTENTION: ce choix est définitif, tu ne pourras pas revenir en arrière. Cette action peut prendre quelques minutes selon le nombre de Ressources à supprimer.",
	"building_deletion_site_details": "Voici le détail de ce site",
	"building_deletion_success": "Site supprimé",
	"building_deletion_success_description": "Le Site \"{buildingId}\" a été supprimé avec succès.",
	"building_display_information_first": "Seuls les utilisateurs ayant l'accès",
	"building_display_information_second": "sur l’outil",
	"building_display_information_third": "peuvent modifier ou supprimer un Site.",
	"building_display_information_end": "Pour devenir un Manager de Sites, n’hésite pas à faire une demande sur",
	"building_creation_building_id_helper_text": "L'id d'un Site est la combinaison Codepays-Ville-NomDuSite",
	"building_floors_placeholder": "Il faut bien séparer les étages par une virgule (0, 1, 2...)",
	"building_floors_helper_text": "Très utile pour grouper les Ressources de votre Site. Cela va aider les Teammates à les retrouver plus facilement.",
	"building_address_helper_text": "Copie l'adresse complète depuis Google Map",
	"building_address": "Adresse du Site",
	"building_address_placeholder": "Colle ici l'adresse",
	"building_name_placeholder": "Entre ici le nom du Site",
	"building_city_placeholder": "Ajoutez ici la ville",
	"building_country_code": "Code du pays",
	"building_creation_information": "Une fois le site créé, son identifiant (ID) ne pourra plus être modifié. Prends un petit instant pour vérifier qu'il te convient avant de valider.<br>⚠️ Attention : Ne saisis pas le code pays ni la ville dans la case \"Nom du Site\". Ces informations sont déjà renseignées dans les deux cases précédentes.",
	"building_creation_no_rights_title": "Tu n'as pas les droits nécessaires pour créer un site.",
	"building_creation_no_rights_description": "Pour devenir gestionnaire/éditeur des Sites, tu dois faire la demande d'accès ",
	"building_edit_title": "Modifier le Site \"{name}\"",
	"building_edit_breadcrumb": "Modifier le Site",
	"building_name": "Nom du Site",
	"building_id_title": "Id (Génération Automatique)",
	"building_id_text": "L'id d'un Site est la combinaison Codepays-Ville-NomDuSite",
	"building_floors_text": "Très utile pour grouper les Ressources de votre Site. Cela va aider les Teammates à les retrouver plus facilement.",
	"building_address_text": "Copie l'adresse complète depuis Google Maps",
	"building_associated": "Site associé",
	"building_country_code_invalid": "Code pays invalide",
	"automatic_generation": "Génération Automatique",
	"create_the_building": "Créer le site",
	"search_building": "Rechercher un site",
	"search_building_empty": "Aucun site trouvé",
	"search_resource": "Rechercher des ressources",
	"calendar_admin_description_first": "Devenez gestionnaire/éditeur du calendrier des ressources des sites.",
	"calendar_admin_description_second": "Vous pourrez voir et modifier les événements sur le calendrier d'une ressource dans Google Agenda.",
	"calendar_admin_description_third": "Recherchez simplement le site et la liste des ressources du site apparaîtra. Faites-les simplement glisser !",
	"exit": "Sortir",
	"country_code": "Code pays",
	"city": "Ville",
	"floors": "Étages",
	"maps_address": "Adresse des cartes",
	"2_letters": "2 lettres",
	"internal_city_name": "Nom de ville interne",
	"watch_out": "Attention",
	"resource_management": "Gestion des ressources",
	"alert_group_2500_members_message": "<strong>C'est complet !</strong><br/> Avec 2 500 membres, ton groupe a atteint sa taille limite. Tu ne peux plus ajouter de nouveaux membres pour le moment.",
	"i_understand": "J'ai compris",
	"internal_building_name": "Nom du site interne",
	"list_being_calculated": "La liste est en cours de calcul. Veuillez rafraichir la page dans <span class=\"colorWarning\">{countdownTime} seconde(s)</span> pour voir la mise à jour effective.",
	"refresh": "Rafraîchir",
	"or": "OU",
	"thanks": "Merci !",
	"understand": "J'ai compris",
	"dynamic_group_description": "Pour créer ton groupe, définis tes critères (pays, site, métier...). <br><br>Ici, la liste se met à jour toute seule : dès qu'un collaborateur répond à tes critères, il rejoint le groupe. S'il ne les remplit plus, il est supprimé. <br><br>Une exception ? Tu peux ajouter des membres à la main, mais attention : ces membres devront être gérés manuellement (membre statique).",
	"static_group_description": "Ajoute des membres manuellement pour un contrôle total. <br><br><strong>Petit rappel :</strong> Tu devras effectuer toi-même les futures mises à jour si la composition de ton groupe change.",
	"groups_error_422_banner_message_1": "Attention : Les filtres actuels n'ont pas pu être repris.",
	"groups_error_422_banner_message_2": "Tu as deux options : ",
	"groups_error_422_banner_message_3": "Les recréer ci-dessous",
	"groups_error_422_banner_message_4": "Abandonner la modification du groupe pour ne pas changer les filtres actuels en appuyant sur le bouton 'Terminer' disponible en bas de page.",
	"massive_import_reading_file_error": "Erreur lors de la lecture du fichier.",
	"contract_type_cdi": "CDI",
	"contract_type_cdd": "CDD",
	"contract_type_intern": "Stagiaire",
	"contract_type_provider": "Prestataire",
	"contract_type_franchise": "Franchise",
	"contract_type_temp": "Intérim",
	"contract_type_generic": "Générique",
	"previous": "Précédent",
	"required_fields": "*champs obligatoires",
	"description_too_short": "Description trop courte (5 caractères minimum)",
	"search_unavailable": "recherche indisponible",
	"search_down_banner_message": "La fonctionnalité de recherche est indisponible pour le moment. Tu peux ajouter le mail de la personne manuellement.",
	"manager_not_found": "Manager non trouvé",
	"errors.multiple_detected": "Il y a {count} erreurs. Réessaie plus tard.",
	"warnings.multiple_detected": "Il y a {count} alertes. Réessaie plus tard.",
	"information.multiple_detected": "Il y a {count} informations.",
	"errors.see_details": "Voir les erreurs",
	"warnings.see_details": "Voir les alertes",
	"success.see_details": "Voir les succès",
	"information.see_details": "Voir les informations",
	"errors.list_description": "Voici les détails des erreurs",
	"errors.list_title": "Récapitulatif des erreurs",
	"warnings.list_description": "Voici les détails des alertes",
	"warnings.list_title": "Récapitulatif des alertes",
	"error.copied": "Erreur copiée avec succès",
	"success.multiple_detected": " {count} succès détectés",
	"success.list_title": "Récapitulatif des succès",
	"success.list_description": "Voici les détails des succès ",
	"information_list_title": "Récapitulatif des informations",
	"information_list_description": "Voici les détails des informations",
	"accounthealth_info": "<strong>Surveille la santé de ton compte.</strong><br>Ces informations aident à comprendre les erreurs en cas de pépin. Jette un œil à tes données : si quelque chose te semble incorrect, contacte ton manager pour faire le point.",
	"3_characters_minimum": "Tu dois écrire au minimum 3 caractères pour lancer la recherche.",
	"error_address_mismatch": "Les adresses principales ne sont pas identiques entre les annuaires LDAP et Google. Une correction est nécessaire pour garantir le bon fonctionnement des services.",
	"error_alias_mismatch": "Les alias ne sont pas identiques entre les annuaires LDAP et Google. Une correction est nécessaire pour garantir le bon fonctionnement des services.",
	"error_internal_serve": "Une erreur interne du serveur s'est produite, veuillez réessayer plus tard.",
	"administrator": "Administrateur",
	"admin_dashboard_access": "Tableau de bord admin",
	"admin_guard_error": "Une erreur est survenue lors de la vérification des droits.",
	"admin_banner_page_title": "Gestion des bannières d'information",
	"admin_banner_existing_title": "Bannières existantes",
	"admin_banner_new": "Nouvelle Bannière",
	"admin_banner_column_id": "ID",
	"admin_banner_column_title": "TITRE",
	"admin_banner_column_message": "MESSAGE PRINCIPAL",
	"admin_banner_column_type": "TYPE",
	"admin_banner_column_status": "STATUT",
	"admin_banner_column_actions": "ACTIONS",
	"admin_banner_status_active": "Active",
	"admin_banner_status_inactive": "Inactive",
	"admin_banner_edit_aria": "Éditer",
	"admin_banner_delete_aria": "Supprimer",
	"admin_banner_empty_message": "Aucune bannière n'a été créée pour le moment.",
	"admin_banner_modal_title_edit": "MODIFIER LA BANNIÈRE",
	"admin_banner_modal_title_create": "CRÉER UNE NOUVELLE BANNIÈRE",
	"admin_banner_form_error_required": "Veuillez remplir le titre et le message de la bannière.",
	"admin_banner_form_title_label": "Titre de la bannière *",
	"admin_banner_form_title_placeholder": "ex: Annonce fermeture magasin",
	"admin_banner_form_message_label": "Texte du message *",
	"admin_banner_form_message_placeholder": "Saisissez le message de la bannière ici...",
	"admin_banner_form_type_label": "Type d'alerte *",
	"admin_banner_action_cancel": "Annuler",
	"admin_banner_action_update": "Mettre à jour",
	"admin_banner_action_create": "Créer la bannière",
	"banner_type_information": "Information",
	"banner_type_warning": "Avertissement",
	"banner_type_danger": "Erreur",
	"banner_type_success": "Succès",
	"teammate": "Collaborateur",
	"site_manager": "Gestionnaire de Site",
	"sync_data": "Synchroniser",
	"groups_email_send_warning": "Le groupe fait plus de 2500 membres, tu ne peux pas activer cette option. Seul un responsable de communication peut autoriser son utilisation pour envoyer des mails. Il doit être manager du groupe pour pouvoir le faire.",
	"groups_enable_email_sending": "Activer l’envoi de mails sur ce groupe",
	"groups_email_sending": "Envoi de mail",
	"groups_email_sending_enable_success": "L'envoi de mail a été activé avec succès.",
	"groups_email_sending_disable_success": "L'envoi de mail a été désactivé avec succès.",
	"groups_email_sending_description": "Si l’option n’est pas activée, vous pourrez toujours faire du partage de fichier pour collaborer, envoyer des RDV au groupe etc...",
	"filter_change_desactivate_email_send_message": "Attention, une fois le filtre appliqué, l’envoi de mail à ce groupe sera bloqué. Une fois la liste des membres recalculée tu devras réactiver l’envoi de mail pour le groupe.",
	"membership_calculation_in_progress": "La liste des membres est toujours en cours de calcul, cette fonctionnalité n’est donc pas active.",
	"calculation_in_progress": "Calcul en cours !",
	"calculation_in_progress_description": "Ajustement de la liste des membres en cours... Patiente quelques secondes.",
	"need_help": "BESOIN D'AIDE ?",
	"contact_support": "Contacter notre support",
	"find_dct_site": "Retrouver notre site DCT",
	"is": "est",
	"are": "sont",
	"creation_in_progress": "en cours de création",
	"creation_groups_in_progress_link": "Voici les liens vers les groupes en cours de création",
	"groups_creation_in_progress": "Groupes en cours de création",
	"groups_creation_step_message_1": "Le groupe est en cours de création, cela peut durer quelques minutes. Voici les étapes en cours",
	"groups_creation_step_message_2": "Tu peux garder cette page ouverte le temps de création et faire un refresh de temps en temps. Une fois les étapes de création finies, tu pourras gérer les membres du groupe via la page d’édition dédiée.",
	"see_the_group": "Voir le groupe",
	"see_the_groups": "Voir les groupes",
	"group_creation_step_1": "Création du groupe",
	"group_creation_step_2": "Ajout en tant que membre",
	"group_creation_step_3": "Mise à jour des paramètres de sécurité",
	"group_creation_step_4": "Ajout en tant que manager du groupe",
	"group_creation_step_5": "création du groupe terminée",
	"service_account_creation_in_progress": "Création du compte de service",
	"service_account_creation_step_message_1": "Le compte de service est en cours de création, cela peut durer quelques minutes. Voici les étapes en cours",
	"service_account_creation_step_message_2": "Tu peux garder cette page ouverte pendant la création. Tu pourras ajouter des membres une fois la création terminée.",
	"service_account_creation_steps": "Étapes de création du compte de service",
	"service_account_creation_step_label": "Étape {step}",
	"site_data_extraction": "Extraction de données d'un site",
	"site_data_extraction_description": "<strong>Toutes tes infos en un clic.</strong><br>Analyse l'activité de ton site sur la période de ton choix et extrais facilement tous les événements et les coûts associés pour tes rapports.",
	"site_data_extraction_reminder": "Extrais facilement tous les événements et les coûts d'un site sur la période de ton choix. Tu peux aussi affiner ton export en ciblant une ressource spécifique si besoin.",
	"search_site_information_message": "Recherche un Site pour trouver les données que tu souhaites extraire.",
	"search_site_information_message_first": "Tout d’abord recherche un site.",
	"search_site_information_message_second": "Puis accède à la gestion des Ressources associées à ce Site.",
	"search_site_calendar_admin_information_message": "Recherche un Site pour trouver les Salles que tu souhaites activer.",
	"download": "Télécharger",
	"extract_other_data": "Extraire d'autres données",
	"access_gmail": "Accéder à gmail",
	"site": "Site",
	"site_data_extracted_information_without_resource": "Site \"{selectedBuildingName}\" sur la plage qui s'étend du {startDate} au {endDate}",
	"site_data_extracted_information_with_resource": "Ressource \"{selectedResource}\" du site \"{selectedBuildingName}\" sur la plage qui s'étend du {startDate} au {endDate}",
	"site_data_extracted_summary": "Voici le récapitulatif de ton extraction",
	"site_data_extracted_in_progress": "L’extraction des données est en cours. Tu recevras un email avec les données brutes en pièce jointe.",
	"site_data_extracted_thanks_message": "Merci, ton extraction est en cours!",
	"site_data_extraction_error_title": "Désolé, il y a un problème lors de la demande d’extraction",
	"site_data_extraction_error_description": "La demande d’extraction des données a échoué, réessaie encore ou essaie avec une autre plage d’extraction. Si le problème persiste, n’hésite pas à créer un Ticket.",
	"site_data_extraction_no_access_message_1": "Désolé, tu n’as pas accès à la gestion d'extraction de données d'un site.",
	"site_data_extraction_no_access_message_2": "Pour devenir gestionnaire de l'extraction de données des sites, tu dois faire la demande d'accès \"MyGoogle - Site Management\" sur Identity Access.",
	"start_date": "Date de départ",
	"end_date": "Date de fin",
	"open_calendar": "Ouvrir le calendrier",
	"selected_site": "Site sélectionné",
	"resource": "Ressource",
	"only_one_resource": "Une Ressource seulement",
	"choose_the_resource": "Choisis la ressource",
	"back_to_form": "Retour au formulaire",
	"create_smax_ticket": "Créer un Ticket SMAX",
	"support": "Support",
	"see_associated_resources": "Voir les Ressources associées",
	"modify": "Modifier",
	"building_edit_warning_title": "Attention si vous mettez à jour un Site, assurez vous que les modifications n’impactent pas l’utilisateur pour retrouver des Ressources.",
	"error_floors_invalid_chars_helper": "Seuls les chiffres, les lettres, les tirets et les astérisques sont autorisés.",
	"error_address_invalid_chars_helper": "Seuls les chiffres, les lettres, les tirets et les virgules sont autorisés.",
	"building_update_success": "Le Site a été modifié avec succès.",
	"error_update_building": "La modification du Site a échoué.",
	"two_letters": "2 lettres",
	"resources_empty_title_message": "Il n’y a pas encore de Ressources sur ce site !",
	"resource_create": "Créer une Ressource",
	"resource_add": "Ajouter une Ressource",
	"resources_associated_to": "Ressources associées à {building}",
	"resource_meet_space": "Espace de rencontre",
	"resource_floor_section": "Section de l'étage",
	"resource_capacity": "Capacité",
	"resource_billing": "Facturation",
	"resource_devices": "Dispositifs",
	"resource_creation_warning_message": "Attention : si vous mettez à jour une Ressource, assurez vous que les modifications n’impactent pas l’utilisateur pour la retrouver. La définition d'informations sur les ressources, telles que le bâtiment, l'étage ou la capacité, affecte les noms de ressources générés automatiquement et la recherche de salles. En cas de modification d’une Ressource, cette dernière est automatiquement décrochée du calendrier.",
	"resource_other": "Autre ressource",
	"resource_unknown": "Non référencée",
	"resource_creation_no_rights_title": "Tu n'as pas les droits nécessaires pour créer une ressource.",
	"resource_features_helper_text": "N'hésite pas à faire des inventaires réguliers pour que la liste soit à jour.",
	"resource_features_placeholder": "Il faut bien les séparer les dispositifs par une virgule (projecteur, écran, ...)",
	"resource_creation_inputs_autorized_letters_helper_text": "Caractères autorisés: A-Z .-_,&'.",
	"resource_creation_inputs_autorized_numbers_helper_text": "Caractères autorisés : chiffres seulement.",
	"resource_billing_placeholder": "Saisir ici la tarification",
	"resource_capacity_placeholder": "Saisir ici la capacité max",
	"resource_type_placeholder": "Saisir ici le type de ressource",
	"resource_section_placeholder": "Saisir ici la section de l'étage",
	"resource_name_placeholder": "Saisir ici le nom de la ressource",
	"resource_category": "Catégorie de la Ressource",
	"resource_category_select": "Sélectionner une catégorie",
	"resource_category_room": "Espace de réunion (salle, cabine téléphonique, ...)",
	"resource_category_other": "Autre ressource (projecteur, véhicule, ...)",
	"resource_id_auto_generated": "Id de la ressource auto-généré",
	"resource_id_generation_helper_text": "L'id d'une Ressource est la combinaison siteName-ressourceName",
	"resource_floor_select": "Sélectionner un étage",
	"resource_associated_not_editable": "Site associé (Non modifiable)",
	"resource_created_title": "ressource créée",
	"resource_created_description": "La ressource {resourceName} a bien été créée.",
	"resource_management_calendar_admin_result_title": "Voici les Ressources liées au Site",
	"resource_management_calendar_admin_result_message": "Tu peux dès à présent activer la gestion / édition du calendrier sur la ou les Ressources que tu souhaites liée à ce site.",
	"resource_management_calendar_search_placeholder": "Rechercher un Site pour accéder à l’activation Admin de ses ressources",
	"resource_management_calendar_admin_title": "<strong>Tes calendriers à portée de main.</strong><br>Active les droits de paramétrage des salles de ton choix. Tu peux maintenant accéder à leurs réglages et piloter les événements directement depuis ton Google Calendar.",
	"resource_management_calendar_admin_no_access_message_1": "Désolé, tu n’as pas accès à la gestion du calendrier des Ressources.",
	"resource_management_calendar_admin_no_access_message_2": "Pour devenir gestionnaire/éditeur du calendrier des Ressources des Sites, tu dois faire la demande d'accès ",
	"resource_edit_breadcrumb": "Modifier la Ressource",
	"resource_edit_title": "Modifier la Ressource du Site \"{building}\"",
	"resource_update_success_title": "Ressource modifiée",
	"resource_update_success_description": "La Ressource {resourceName} a été modifiée avec succès.",
	"resource_update_error_title": "Une erreur est survenue lors de la modification de la Ressource.",
	"no_results_for_building": "Pas de résultat pour \"{selectedBuilding}\"",
	"creation_new_resource": "Création d’une nouvelle Ressource",
	"creation_new_resource_of_building": "Création d’une nouvelle Ressource du Site {building}",
	"create_the_resource": "Créer la ressource",
	"edit_the_resource": "Modifier la ressource",
	"devices": "Dispositif(s) qui accompagne(nt) la ressource (optionnel)",
	"billing": "Facturation",
	"back_home_page": "Retour à l'accueil",
	"banner_delete_resources_message": "Les ressources du building \"{buildingId}\" sont en cours de suppression. Cela peut prendre quelques minutes.",
	"resource_deletion_title": "Veux-tu vraiment supprimer la Ressource  \"{resourceName}\" ?",
	"resource_deletion_warning": "<span class=\"vtmn-font-bold\">ATTENTION</span> : Ce choix est définitif, tu ne pourras pas revenir en arrière.",
	"resource_deletion_details": "Voici les détails liés à cette Ressource : {resourceDetails}",
	"resource_deletion_success": "Ressource supprimée",
	"resource_deletion_success_description": "La Ressource à été supprimé avec succès",
	"too_short_email": "Nom trop court (3 caractères minimum)",
	"identity_access": "Identity Access",
	"access_to_identity_access": "Accès vers Identity Access",
	"on": "sur",
	"mygoogle_support": "MyGoogle - Support",
	"mygoogle_site_management": "MyGoogle - Site Management",
	"search_group_information_message_first": "Tout d'abord, recherche un groupe.",
	"search_group_information_message_second": "Puis accède aux détails ou à la gestion de ce dernier.",
	"group_message": "<strong>Gère tes groupes en toute simplicité.</strong><br/>Visualise les groupes auxquels tu appartiens et gère ceux dont tu as les droits directement depuis cet espace. ",
	"search_sharedmailbox_information_message_first": "Tout d'abord, recherche une boîte mail partagée.",
	"search_sharedmailbox_information_message_second": "Puis accède aux détails ou à la gestion de celle-ci.",
	"search_service_account_information_message_first": "Cherche le compte de service dont tu as besoin et accède directement à ses paramètres.",
	"search_group_underscore_warning": "Pour rechercher un groupe dont le nom contient un underscore (_), pensez à inclure cet underscore dans votre recherche",
	"search_group_underscore_example": "(ex. : recherchez 'nom_' pour trouver 'nom_groupe')",
	"dynamic": "Dynamique",
	"static": "Statique",
	"unknown": "Inconnu",
	"visualize": "Visualiser",
	"dynamic_groups_alert_title": "⚠️ Groupes dynamiques",
	"dynamic_groups_alert_description": "La modification des groupes dynamiques est exclusive au rôle <strong>MyGoogle - Communicator</strong> (attribué d'office aux managers, équipes Communication et Office Managers).",
	"dynamic_groups_alert_how_to": "Comment procéder ?",
	"dynamic_groups_alert_check_role": "Vérifier mon rôle",
	"dynamic_groups_alert_has_role": "Tu as le rôle ?",
	"dynamic_groups_alert_training": "Suivre la formation obligatoire",
	"dynamic_groups_alert_no_role": "Tu n'as pas le rôle ? Ton manager le possède déjà ! Tu peux l'ajouter en tant que délégué(e) pour gérer le groupe.",
	"dynamic_groups_alert_creation_blocked": "Actuellement la création de groupes dynamiques est bloquée.",
	"dynamic_groups_alert_follow_evolution": "Suivez l'évolution des groupes dynamiques et nos prochaines étapes sur ce lien :",
	"dynamic_groups_alert_dct_site": "Site DCT",
	"meeting_room_manager": "Gestionnaire de salles de réunion",
	"meeting_room_manager_description": "<strong>Trouvez et réservez des salles de réunion.</strong><br>Recherchez par bâtiment, vérifiez la disponibilité des salles et téléchargez les QR codes pour des réservations rapides.",
	"mrm_step1_title": "Sélectionner un bâtiment",
	"mrm_step1_description": "Recherchez et sélectionnez le bâtiment dans lequel vous souhaitez afficher le statut des salles en direct",
	"mrm_step2_title": "Sélectionner un étage et rechercher",
	"mrm_step2_description": "Choisissez un étage et recherchez les salles disponibles.",
	"mrm_next": "Suivant",
	"mrm_search_buildings_label": "Rechercher des bâtiments",
	"mrm_search_building_placeholder": "Rechercher un bâtiment...",
	"mrm_no_buildings_found": "Aucun bâtiment trouvé.",
	"mrm_select_floors_optional": "Sélectionner des étages (facultatif) :",
	"mrm_show_available_rooms_only_label": "Afficher uniquement les salles disponibles",
	"mrm_downloading": "Téléchargement...",
	"mrm_download_qr_codes": "Télécharger les QR codes",
	"mrm_show_rooms": "Afficher les salles",
	"mrm_please_select_building_first": "Veuillez d'abord sélectionner un bâtiment.",
	"mrm_qr_codes_downloaded_success": "QR codes téléchargés avec succès",
	"mrm_qr_codes_download_failed": "Échec du téléchargement des QR codes",
	"mrm_rooms_page_title": "{buildingName} — Salles",
	"mrm_no_rooms_found": "Aucune salle trouvée.",
	"mrm_no_rooms_found_description": "Aucune salle de réunion n'est disponible pour ce bâtiment.",
	"mrm_auto_scroll_label": "Défilement automatique",
	"mrm_free": "Libre",
	"mrm_available_at": "Disponible à {time}",
	"mrm_confirm_reservation_title": "Confirmer la réservation",
	"mrm_reservation_confirmed": "Réservation confirmée",
	"mrm_back_to_meeting_room_manager": "Retour au gestionnaire de salles de réunion",
	"mrm_room_label": "Salle :",
	"mrm_start_date": "Date de début",
	"mrm_start_time": "Heure de début",
	"mrm_end_date": "Date de fin",
	"mrm_end_time": "Heure de fin",
	"mrm_confirming": "Confirmation...",
	"mrm_confirm_reservation_button": "Confirmer la réservation",
	"mrm_fill_all_date_time_fields": "Veuillez renseigner tous les champs de date/heure",
	"mrm_room_booked_success": "Salle réservée avec succès !",
	"mrm_room_booking_failed": "Échec de la réservation de la salle",
	"mrm_confirmation_failed": "Impossible de confirmer la salle",
	"mrm_no_event_to_confirm": "Aucun événement à confirmer",
	"mrm_try_again_later": "Veuillez réessayer plus tard.",
	"roles": "Rôles",
	"assigned_access": "Accès attribués",
	"my_roles": "Mes rôles",
	"no_role_assigned": "Aucun rôle attribué",
	"role_admin": "Administrateur",
	"role_communicator": "Communicateur",
	"role_site_manager": "Gestionnaire de Sites",
	"role_support": "Support",
	"role_teammate": "Collaborateur"
}
